// A summary of Packer Errors
import React from "react";
import WhiteBox from "../../Styled/WhiteBox";

export default function PackerErrors() {
  return <WhiteBox>Packer Errors</WhiteBox>;
}
